<div class="flex my-3">
  <label class="{{ labelStyleClass }}">
    {{ label }}
    <span *ngIf="required">*</span>
  </label>
  <div class="{{ inputWrapperStyleClass }}">
    <ng-content select="[input]"></ng-content>
    <common-validation-errors [control]="control"></common-validation-errors>
  </div>
</div>
<div
  *ngIf="false"
  class="w-2/12 w-3/12 w-4/12 w-5/12 w-6/12 w-7/12 w-8/12 w-9/12 w-10/12"
></div>
